import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Target, ShieldCheck, Headphones, Zap, Users, TrendingUp } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <Target className="w-8 h-8 text-brand-orange" data-id="element-11" />,
    title: 'Leads Exclusivos',
    description: 'Cada lead es tuyo y solo tuyo. No compartimos leads con otros agentes.'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-brand-orange" data-id="element-12" />,
    title: 'Verificados en Tiempo Real',
    description: 'Cada prospecto es verificado antes de enviártelo para maximizar tu conversión.'
  }, {
    icon: <Headphones className="w-8 h-8 text-brand-orange" data-id="element-13" />,
    title: 'Soporte 100% en Español',
    description: 'Nuestro equipo habla tu idioma y entiende tu mercado.'
  }, {
    icon: <Zap className="w-8 h-8 text-brand-orange" data-id="element-14" />,
    title: 'Entrega Instantánea',
    description: 'Recibe leads directamente en tu teléfono en el momento que se generan.'
  }, {
    icon: <Users className="w-8 h-8 text-brand-orange" data-id="element-15" />,
    title: 'Entrenamiento Incluido',
    description: 'Te enseñamos exactamente cómo contactar y cerrar cada lead.'
  }, {
    icon: <TrendingUp className="w-8 h-8 text-brand-orange" data-id="element-16" />,
    title: 'Resultados Comprobados',
    description: 'Nuestro equipo vende seguros con estos mismos leads todos los días.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="bg-white py-12 md:py-16 px-4" data-id="element-17">
      <div className="max-w-7xl mx-auto" data-id="element-18">
        <div className="text-center mb-10" data-id="element-19">
          <span className="block text-sm font-bold tracking-widest text-brand-orange uppercase mb-4" data-id="element-20">
            Por Qué Elegirnos
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal text-balance" data-id="element-21">
            ¿Por Qué Miles de Agentes Confían en X Leads?
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-22">
          {benefits.map((benefit, index) => <motion.div key={index} variants={cardVariants} className="bg-gray-50 rounded-2xl p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-gray-100" data-id="element-23">
              <div className="bg-orange-50 w-14 h-14 rounded-xl flex items-center justify-center mb-4" data-id="element-24">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-charcoal mb-2" data-id="element-25">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-26">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}